module.exports = __webpack_public_path__ + "img/62d4550.jpg";